import Helper from '../helpers/Helper';

export default class TopButton {
    constructor() {
        this.el = null;
    }
    init(el) {
        if (el === undefined || el === null) {
            return;
        }
        this.el = el;
        this.bind();
    }
    bind() {
        this.addClass();
        this.show();
        this.el.style.display = 'block';
        (Helper.isInsideEditor() ? document.querySelector('.page-wrap') : window).addEventListener(
            'scroll',
            () => {
                this.show();
            }
        );
        this.el.addEventListener('click', (e) => {
            this.scrollTo(0, 666);
            e.preventDefault();
        });
    }
    addClass() {
        if (Helper.isInsideEditor()) {
            this.el.classList.add('top-button--more-margin');
        }
    }
    show() {
        if (
            this.scrollTop() >= window.innerHeight / 2 &&
            !this.el.classList.contains('top-button--visible')
        ) {
            this.el.classList.add('top-button--visible');
        }
        if (
            this.scrollTop() < window.innerHeight / 2 &&
            this.el.classList.contains('top-button--visible')
        ) {
            this.el.classList.remove('top-button--visible');
        }
    }
    scrollTop() {
        if (Helper.isInsideEditor()) {
            return document.querySelector('.page-wrap').scrollTop;
        } else {
            return (
                (window.pageYOffset || document.documentElement.scrollTop) -
                (document.documentElement.clientTop || 0)
            );
        }
    }
    scrollTo(to, duration = 1000) {
        var element = Helper.isInsideEditor()
                ? document.querySelector('.page-wrap')
                : document.scrollingElement || document.documentElement,
            start = element.scrollTop,
            change = to - start,
            startDate = +new Date(),
            // t = current time
            // b = start value
            // c = change in value
            // d = duration
            easeInOutCirc = function(t, b, c, d) {
                t /= d / 2;
                if (t < 1) return (-c / 2) * (Math.sqrt(1 - t * t) - 1) + b;
                t -= 2;
                return (c / 2) * (Math.sqrt(1 - t * t) + 1) + b;
            },
            animateScroll = function() {
                var currentDate = +new Date();
                var currentTime = currentDate - startDate;
                element.scrollTop = parseInt(easeInOutCirc(currentTime, start, change, duration));
                if (currentTime < duration) {
                    requestAnimationFrame(animateScroll);
                } else {
                    element.scrollTop = to;
                }
            };
        animateScroll();
    }
}
